module.exports = __webpack_public_path__ + "img/sweat1.ace5ffbd.png";